import { CostApplication } from '@Types/rehab.types';

export interface CostApplicationOption {
	value: CostApplication;
	label: string;
}

/**
 * Builds the "Apply to" select options shared between cost-table-sourced and
 * custom-cost actions so the labels/i18n keys never diverge between the two.
 */
export const getCostApplicationOptions = (
	t: (key: string) => string,
	system: 'Metric' | 'Imperial',
): CostApplicationOption[] => [
	{
		value: CostApplication.pipeLength,
		label: system === 'Metric' ? t('/m (pipe length)') : t('/ft (pipe length)'),
	},
	{
		value: CostApplication.trenchLength,
		label: system === 'Metric' ? t('/m (rehab length)') : t('/ft (rehab length)'),
	},
];
